var React = require('react');

function SoundOff (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m15.025 4.664 5.896 5.896m-5.896 0 5.896-5.895","strokeWidth":"1.25","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"m11.565 1.366-5.63 3.396H2.727c-.673 0-1.22.542-1.22 1.211v3.382c0 .668.547 1.21 1.22 1.21h3.208l5.63 3.397a.512.512 0 0 0 .777-.434V1.8a.512.512 0 0 0-.777-.434Z","strokeWidth":"1.25","strokeMiterlimit":"10","strokeLinecap":"round","key":1})]);
}

SoundOff.defaultProps = {"width":"22","height":"15","fill":"none"};

module.exports = SoundOff;

SoundOff.default = SoundOff;
